import { Input } from '@nazka/nazka.mapframe.components'

import './search-filter.styl'

function SearchFilter({ value, setValue }) {
  return (
    <Input
      className="search-filter"
      placeholder="Search..."
      onInputChange={e => setValue(e.target.value)}
      value={value}
    />
  )
}

export default SearchFilter
